/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class AddContactDialog extends Serenity.TemplatedDialog<AddContactDialogOptions> {

        constructor(opt: AddContactDialogOptions) {
            super(opt);
            var $this = this;
            this.dialogTitle = "Add Contacts";
            var button1 = $(`<button class="btn btn-primary mt-3 mx-8 w-100"><i class="fa fa-users text-blue"></i> Add from Contacts</button>`);
            button1.on("click", () => {
                var dlg = new ContactPickerDialog({
                    hideProducts: this.options.ID
                });
                dlg.onSuccess = (selected) => {
                    // filter already existing products
                    //Q.serviceCall({
                    //    blockUI: false,
                    //    service: "/Services/Nobox/Contact/SaveFromContact",
                    //    request: {
                    //        ListId: `${this.options.ID}`,
                    //        ListContact: selected
                    //    },
                    //    onSuccess: function (res) {
                    //        Q.notifySuccess(`Success Add ${res.CustomData.Update} contact to this list`);
                    //        $this.options.leadsGrid.refresh();
                    //    },
                    //    onError: function (error) {
                    //        Q.notifyError("Error add contact to this list")
                    //    }
                    //})
                    //$this.dialogClose();
                    this.dialogClose();
                    var contactIds = selected.split(",");
                    var action = new ContactPickerBulkAction();
                    action.ListId = this.options.ID;
                    action.Url = "/Services/Nobox/Contact/SaveFromContact";
                    action.done = () => {
                        $this.options.leadsGrid.refresh();
                    };
                    action.execute(contactIds);
                    return true;
                };
                dlg.dialogOpen();
            });
            var button2 = $(`<button class="btn btn-primary mt-3 mx-8 w-100"><i class="fa fa-crosshairs text-blue"></i> Add from Campaign Targets</button>`);
            button2.on("click", () => {
                var dlg = new CampaignPickerDialog({
                    hideProducts: this.options.ID
                });
                dlg.onSuccess = (selected) => {
                    // filter already existing products
                    this.dialogClose();
                    var contactIdsSementara = selected.split(",");
                    var contactIds = contactIdsSementara.filter((c, index) => {
                        return contactIdsSementara.indexOf(c) === index;
                    });
                    var action = new ContactPickerBulkAction();
                    action.ListId = this.options.ID;
                    action.Url = "/Services/Nobox/Contact/SaveFromCampaign";
                    action.done = () => {
                        $this.options.leadsGrid.refresh();
                    };
                    action.execute(contactIds);
                    //Q.serviceCall({
                    //    blockUI: false,
                    //    service: "/Services/Nobox/Contact/SaveFromCampaign",
                    //    request: {
                    //        ListId: `${this.options.ID}`,
                    //        ListContact: selected
                    //    },
                    //    onSuccess: function (res) {
                    //        Q.notifySuccess(`Success Add ${res.CustomData.Insert} contact to this list`);
                    //        $this.options.leadsGrid.refresh();
                    //    },
                    //    onError: function (error) {
                    //        Q.notifyError("Error add contact to this list")
                    //    }
                    //});
                    //$this.dialogClose();
                    return true;
                };
                dlg.dialogOpen();
            });
            var button3 = $("<div></div>").append(button1, button2);
            this.byId('DialogPicker').append(button3);
        }

        handleResponsive() {

        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [];
        }

        protected getTemplate() {
            return "<div id='~_DialogPicker'></div>";
        }
    }
    export interface AddContactDialogOptions {
        ID: string;
        leadsGrid: ListLeadGrid;
    }
}